(() => {
  const config = document.querySelector('[data-hg-sow-config]');
  const specs = document.querySelector('.hg-grow-card__specs');
  if (!config || !specs) return;
  const zonePicker = document.querySelector('[data-hg-zone-picker]');
  let dataPromise;
  let data;
  const getData = () => dataPromise ??= fetch(config.dataset.asset).then((response) => {
    if (!response.ok) throw new Error(`Sow asset HTTP ${response.status}`);
    return response.json();
  });
  const system = zonePicker?.dataset.system || 'US';
  const key = `hg-zone-${system}`;
  const savedZone = () => {
    try { return localStorage.getItem(key) ?? (system === 'US' ? localStorage.getItem('hg-zone') : null); }
    catch (_) { return null; }
  };
  const region = system === 'CA' ? ['canada_toronto', 'Toronto']
    : system === 'GB' ? ['uk_london', 'London']
      : system === 'EU' ? ['eu_frankfurt', 'Frankfurt'] : null;
  const panel = document.createElement('div');
  panel.className = 'hg-when-to-sow';
  panel.setAttribute('aria-live', 'polite');
  panel.setAttribute('aria-busy', 'true');
  specs.after(panel);

  const date = (mmdd) => new Date(Date.UTC(2025, Number(mmdd.slice(0, 2)) - 1, Number(mmdd.slice(2))));
  const offset = (day, weeks) => new Date(day.getTime() + weeks * 7 * 86400000);
  const format = (day) => new Intl.DateTimeFormat(document.documentElement.lang?.startsWith('es') ? 'es-US' : 'en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(day);
  const range = (start, end) => `${format(start)} – ${format(end)}`;
  const make = (tag, className, value) => {
    const node = document.createElement(tag);
    node.className = className;
    node.textContent = value;
    return node;
  };
  function selectedFrost() {
    if (region) return { dates: data.regions[region[0]], label: config.dataset.region.replace('__CITY__', region[1]) };
    // Same zone the header chip shows (zone-picker sets dataset.zone, including its default).
    const chosen = savedZone() || document.documentElement.dataset.zone;
    if (!chosen) return null;
    const zone = String(document.documentElement.dataset.zone || chosen);
    return { dates: data.frost[zone], label: document.documentElement.dataset.zoneLabel || `Zone ${zone}` };
  }
  function render() {
    if (!data || !data.products[config.dataset.handle] || !specs.isConnected) { panel.hidden = true; return; }
    const crop = data.crops[data.products[config.dataset.handle]];
    if (!crop) { panel.hidden = true; return; }
    panel.replaceChildren();
    panel.hidden = false;
    panel.append(make('h3', 'hg-when-to-sow__title', config.dataset.title));
    const frost = selectedFrost();
    if (!frost?.dates) {
      const prompt = make('p', 'hg-when-to-sow__prompt', config.dataset.prompt);
      const button = make('button', 'hg-when-to-sow__button', config.dataset.pick);
      button.type = 'button';
      button.addEventListener('click', () => document.querySelector('[data-hg-zone-picker] [data-hg-zone-open]')?.click());
      panel.append(prompt, button);
      return;
    }
    panel.append(make('p', 'hg-when-to-sow__zone', frost.label));
    const rows = [];
    if (frost.dates === 'frost-free') {
      if (crop[0] === 'cool' && (crop[2] || crop[3])) {
        rows.push([config.dataset.outdoor, range(date('0901'), new Date(Date.UTC(2026, 1, 28)))]);
      } else if (crop[1] || crop[2] || crop[3]) {
        rows.push([config.dataset.outdoor, config.dataset.warm]);
      }
      panel.append(make('p', 'hg-when-to-sow__zone', config.dataset.frostFree));
    } else {
      const last = date(frost.dates[0]);
      const first = date(frost.dates[1]);
      if (crop[1]) rows.push([config.dataset.indoor, range(offset(last, -Math.max(...crop[1])), offset(last, -Math.min(...crop[1])))]);
      if (crop[2]) rows.push([config.dataset.outdoor, range(offset(last, Math.min(...crop[2])), offset(last, Math.max(...crop[2])))]);
      if (crop[3]) rows.push([config.dataset.fall, range(offset(first, -Math.max(...crop[3])), offset(first, -Math.min(...crop[3])))]);
    }
    for (const [label, value] of rows.slice(0, 3)) {
      const row = make('div', 'hg-when-to-sow__row', '');
      row.append(make('span', 'hg-when-to-sow__label', label), make('strong', 'hg-when-to-sow__dates', value));
      panel.append(row);
    }
    panel.append(make('p', 'hg-when-to-sow__footnote', config.dataset.footnote));
  }
  document.addEventListener('hg:zone-change', render);
  document.addEventListener('shopify:section:load', render);
  getData().then((result) => { data = result; panel.removeAttribute('aria-busy'); render(); }).catch(() => { panel.hidden = true; });
})();
